import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accentColor", "children", "onClick", "variant"];
import styled, { css } from 'styled-components';
import { getCanReadTextOnce } from 'visitor-ui-component-library/utils/colors';
import { OBSIDIAN, NEUTRAL_200, NEUTRAL_300, NEUTRAL_500, NEUTRAL_800, NEUTRAL_900, NEUTRAL_1600, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { getFocusRingStyles } from 'visitor-ui-component-library/utils/getFocusRingStyles';
import { promptButtonBaseStyles } from '../shared/components/BasePromptButton';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultVariantStyles = css(["", " background:", ";color:", ";border:1px solid ", ";cursor:pointer;&:hover:not(:disabled){color:", ";border-color:", ";}&:disabled{opacity:0.6;cursor:not-allowed;}"], promptButtonBaseStyles, WHITE, OBSIDIAN, NEUTRAL_800, ({
  $accentColor
}) => $accentColor || NEUTRAL_900, ({
  $accentColor
}) => $accentColor || NEUTRAL_900);
const aiSdrVariantStyles = css(["display:flex;align-items:center;gap:8px;background:", ";color:", ";border:1.5px solid ", ";border-radius:9999px;padding:8px 16px;font-size:14px;font-weight:400;line-height:20px;cursor:pointer;box-sizing:border-box;text-align:left;transition:background-color 0.15s ease,border-color 0.15s ease;&:hover{background-color:", ";border:1.5px solid ", ";}&:active{background-color:", ";border:1.5px solid ", ";}", ""], WHITE, NEUTRAL_1600, NEUTRAL_500, NEUTRAL_200, NEUTRAL_800, NEUTRAL_300, NEUTRAL_800, getFocusRingStyles({
  outlineOffset: '2px'
}));
const QuickReplyButtonStyled = styled.button.withConfig({
  displayName: "QuickReplyButton__QuickReplyButtonStyled"
})(["", ""], ({
  $variant
}) => $variant === 'aiSdr' ? aiSdrVariantStyles : defaultVariantStyles);
const QuickReplyButton = _ref => {
  let {
      accentColor = OBSIDIAN,
      children,
      onClick,
      variant = 'default'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTextReadable = getCanReadTextOnce(accentColor);
  const accessibleAccentColor = isTextReadable ? accentColor : OBSIDIAN;
  return /*#__PURE__*/_jsx(QuickReplyButtonStyled, Object.assign({
    $accentColor: accessibleAccentColor,
    $variant: variant,
    onClick: onClick
  }, props, {
    children: children
  }));
};
QuickReplyButton.displayName = 'QuickReplyButton';
export default QuickReplyButton;